import { useState, useEffect } from "react";
import { db } from "config/firebase";
import { doc, onSnapshot, Unsubscribe } from "firebase/firestore";

interface MessageCount {
  numMsgs: number;
  unreadMsgs: number;
  unreadMsg?: boolean;
}

interface UseMessageCountProps {
  userId: string | null;
}

/**
 * Custom hook that manages the unread message count listener
 * Returns the current message count state and automatically handles cleanup
 */
export const useMessageCount = ({ userId }: UseMessageCountProps) => {
  const [messageCount, setMessageCount] = useState<MessageCount | null>(null);

  useEffect(() => {
    if (!userId) {
      setMessageCount(null);
      return;
    }

    const docRef = doc(db, `users/${userId}/data/messages`);
    
    const unsubscribe: Unsubscribe = onSnapshot(
      docRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data() as MessageCount;
          setMessageCount(data);
        } else {
          setMessageCount(null);
        }
      },
      (error) => {
        console.error("Message count listener error:", error);
        setMessageCount(null);
      },
    );

    // Cleanup function
    return () => {
      console.log("Cleaning up message count listener");
      unsubscribe();
    };
  }, [userId]);

  return messageCount;
};

export default useMessageCount;